<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">VIP用户管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>城市：</label>
          <Area title="" @areaChang='getArea($event)' :reset="resetArea"/>
        </div>
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em" @change="sexChange">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>套餐项目：</label>
          <el-select v-model="vipId" placeholder="请选择" size="mini" style="width: 10em;">
            <el-option v-for="item in vipIdArray" :key="item.id" :label="item.name + (item.sex == 0?':通用':item.sex == 1?':男':item.sex == 2?':女':'') + (item.state == 0?'（待上架）':item.state == 1?'（上架中）':item.state == 2?'（已下架）':'')" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>套餐状态：</label>
          <el-select v-model="vipState" placeholder="请选择" size="mini" style="width: 6em;">
            <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>订阅状态：</label>
          <el-select v-model="userSignedState" placeholder="请选择" size="mini" style="width: 6em;">
            <el-option v-for="item in userSignedStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>支付方式：</label>
          <el-select v-model="vipPayMode" placeholder="请选择" size="mini" style="width: 6em;">
            <el-option v-for="item in vipPayModeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>开通类型：</label>
          <el-select v-model="vipPayType" placeholder="请选择" size="mini" style="width: 6em;">
            <el-option v-for="item in vipPayTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>vip获取方式：</label>
          <el-select v-model="obtainMethod" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in obtainMethodArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>开通次数：</label>
          <el-select v-model="openNum" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in openNumArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="开通时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="生日时间：" @date="getBirthdayTime($event)" @check="getBirthdayCheck($event)" :isChecked="isBirthdayChecked"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="注册时间：" @date="getRegTime($event)" @check="getRegCheck($event)" :isChecked="isRegChecked"/>
        </div>
        <div class="content-input-item">
          <label>认证方式：</label>
          <el-select v-model="identityType" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in identityTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>信息状态：</label>
          <el-select v-model="resumeState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in resumeStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号状态：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ChannelPackageList :packageName="packageName" :channel="channel" @getChange="getChannelPackage" />
        </div>
        <div class="content-input-item">
          <SearchComponents @searchType="getSearchType($event)" @searchValue="getSearchValue($event)"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)" :type="2"/>
          <el-input v-model="searchBillValue" placeholder="请输入订单号" clearable style="width: 20em"/>
          <el-button style="margin-left: 8px;" type="success" @click="getSearchBill" v-loading="searchBillLoading"> 查询 </el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="updateTime" label="开通时间" v-if="checkColList.indexOf('开通时间') > -1" width="110"/>
          <el-table-column property="regTime" label="注册时间" v-if="checkColList.indexOf('注册时间') > -1" width="110"/>
          <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1" class-name="cursor" width="110">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,birth,city"/>
            </template>
          </el-table-column>
          <el-table-column prop="" label="用户状态" v-if="checkColList.indexOf('用户状态') > -1" width="180">
            <template #default="scope">
              <p>信息审核：{{scope.row.resumeState == 0 ? "未提交" : scope.row.resumeState == 1 ? "待审核" : scope.row.resumeState == 2 ? "已通过" : scope.row.resumeState == 3 ? "不通过" : "--"}}</p>
              <p>身份证认证：{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
              <p>微信审核：{{scope.row.wechatState == 0 ? '未提交' : scope.row.wechatState == 1 ? '待审核' : scope.row.wechatState == 2 ? '已通过' : scope.row.wechatState == 3 ? '不通过' : '--'}}</p>
              <p>是否是vip：<span style="color: #3a8ee6">{{scope.row.vipState == 0 ? '否' : scope.row.vipState == 1 ? '是' : scope.row.vipState == 2 ? '是' : '--'}}</span></p>
              <p>封号状态：<span :style="{color: scope.row.isForbidden?'red':''}">{{ scope.row.isForbidden?'已封号':'未封号'}}</span></p>
              <p>冻结设备：<span :style="{color: scope.row.isIdfaBan?'red':''}">{{ scope.row.isIdfaBan?'已冻结':'未冻结'}}</span></p>
            </template>
          </el-table-column>
          <el-table-column label="认证情况" v-if="checkColList.indexOf('认证情况') > -1" width="180">
            <template #default="scope">
              <p>身份认证：{{scope.row.identityAuth.identityState == 0 ? "未认证未提交" : scope.row.identityAuth.identityState == 1 ? "申请认证" : scope.row.identityAuth.identityState == 2 ? "已认证" : scope.row.identityAuth.identityState == 3 ? "认证不通过" : scope.row.identityAuth.identityState == 4 ? "正面认证不通过" : scope.row.identityAuth.identityState == 5 ? "反面认证不通过" : ""}}</p>
              <p>芝麻认证：{{scope.row.identityAuth.zhimaState == 0 ? "不通过" : scope.row.identityAuth.zhimaState == 1 ? "通过" : ""}}</p>
              <p>百度认证：{{scope.row.identityAuth.baiduState == 0 ? "不通过" : scope.row.identityAuth.baiduState == 1 ? "通过" : ""}}</p>
              <p>视频认证：<span v-if="scope.row.authVideo">{{scope.row.authVideo.state == 1 ? "待审核" : scope.row.authVideo.state == 2 ? "审核通过" : scope.row.authVideo.state == 3 ? "审核不通过" : ""}}</span></p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="VIP状态" v-if="checkColList.indexOf('VIP状态') > -1" width="150">
            <template #default="scope">
              <p>
                剩余时间：
                <span v-if="scope.row.vipState == 2">终身VIP</span>
                <span v-if="scope.row.expireDay">{{ scope.row.expireDay }}天</span>
              </p>
              <p>开通次数：{{scope.row.openNum}}</p>
              <p>状态：{{ scope.row.state == 1 ? '正常' : scope.row.state == 2 ? '已解除' : scope.row.state == 3 ? '已过期' : '&#45;&#45;' }}</p>
            </template>
          </el-table-column>
<!--          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">-->
<!--            <template #default="scope">-->
<!--              <p>{{ scope.row.state == 1 ? '正常' : scope.row.state == 2 ? '已解除' : scope.row.state == 3 ? '已过期' : '&#45;&#45;' }}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="" label="vip记录" v-if="checkColList.indexOf('vip记录') > -1" min-width="200" class-name="cursor" width="220">
            <template #default="scope">
              <UserVipLog :user-log-list="scope.row.vipDtList" />
            </template>
          </el-table-column>
          <el-table-column property="" label="SVIP记录" v-if="checkColList.indexOf('SVIP记录') > -1" class-name="cursor" width="220">
            <template #default="scope">
              <MarriageLog :user-log-list="scope.row.marriageDtList" />
            </template>
          </el-table-column>
<!--          <el-table-column prop="openNum" label="开通次数" v-if="checkColList.indexOf('开通次数') > -1"></el-table-column>-->
          <el-table-column prop="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="120">
            <template #default="scope">
              <el-space direction="vertical" alignment="left" >
                <el-button type="primary" size="small" v-if="scope.row.vipState != 2" @click="updateDialog(scope.row)">赠送/扣除</el-button>
                <el-button type="success" size="small" v-if="scope.row.vipState != 2" @click="updateExpire(scope.$index, scope.row, 2)" v-loading="scope.row.updateLoading">赠送终身VIP</el-button>
                <el-button type="danger" size="small" @click="updateExpire(scope.$index, scope.row, 0)" v-loading="scope.row.updateLoading">解除服务</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange_30'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getVipUserPageList, updateVipUserExpire, getVipAllList, getSearchBillInfo
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import UserVipLog from "@/components/VipLog/UserVipLog";
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import VipUserSearchInfoDialog from "@/views/vip/components/VipUserSearchInfoDialog";
import { common } from "@/assets/shared/select-constant";
import UserVipLogDialog from "@/components/VipLog/UserVipLogDialog";
import UserUpdateDialog from "@/views/vip/components/UserUpdateDialog";
import SearchBillInfoDialog from "@/views/vip/components/SearchBillInfoDialog";
import Area from '@/components/AreaSelectSvip'
import ChannelPackageList from "@/components/resume/ChannelPackageList_c";
import MarriageLog from "@/components/MarriageLog/MarriageLog";
import MarriageLogDialog from "@/components/MarriageLog/MarriageLogDialog";

export default {
  name: "VipUser",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog, SearchUidOrPhone, UserVipLog, MarriageLog, Area, ChannelPackageList },
  data() {
    return {

      //性别
      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      //套餐类型
      vipIdArray: [
        {"name": "不限", "id": 0}
      ],
      vipId: 0,
      vipManArr: [],
      vipWomanArr: [],
      vipBothArr: [],

      //套餐状态
      vipStateArray: [
        {label: "不限", value: -1},
        {label: "上架中", value: 1},
        {label: "已下架", value: 2}
      ],
      vipState: 1,

      //订阅状态
      userSignedStateArray: [
        {label: "不限", value: -1},
        {label: "未订阅", value: 0},
        {label: "订阅中", value: 1},
        {label: "购买后取消", value: 2},
        {label: "购买中取消", value: 3},
      ],
      userSignedState: -1,


      //支付方式
      vipPayModeArray: [
        {label: "不限", value: -1},
        {label: "支付宝", value: 1},
        {label: "微信", value: 2}
      ],
      vipPayMode: -1,


      //开通类型
      vipPayTypeArray: [
        {label: "不限", value: -1},
        {label: "普通类型", value: 1},
        {label: "订阅类型", value: 2},
        {label: "续费成功", value: 3},
      ],
      vipPayType: -1,


      //状态
      stateArray: [
        {label: "不限", value: -1},
        {label: "正常", value: 1},
        {label: "已解除", value: 2},
        {label: "已过期", value: 3},
      ],
      state: -1,

      // vip获取方式
      obtainMethodArray: [
        {label: "不限", value: -1},
        {label: "充值购买", value: 0},
        {label: "邀请好友获得", value: 1},
        {label: "后台赠送", value: 2},
        {label: "金币兑换", value: 3},
        {label: "0元体验", value: 4},
      ],
      obtainMethod: -1,

      // 开通次数
      openNumArray: [
        {label: "不限", value: 0},
        {label: "1", value: 1},
        {label: "2", value: 2},
        {label: "3", value: 3},
        {label: "4", value: 4},
        {label: "5", value: 5},
        {label: "6", value: 6},
        {label: "7", value: 7},
        {label: "8", value: 8},
        {label: "9", value: 9},
        {label: "10", value: 10},
        {label: "10以上", value: 11}
      ],
      openNum: 0,

      //开通时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //生日时间
      birthdayStartTime: '',
      birthdayEndTime: '',
      isBirthdayChecked: true,

      //注册时间
      regStartTime: '',
      regEndTime: '',
      isRegChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['开通时间', '注册时间', '头像', '用户信息', '用户状态', '认证情况', 'VIP状态', 'vip记录', 'SVIP记录', '开通次数', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      updateReLoading: false,
      updateNewLoading: false,

      idArray: [],

      //查询订单号
      searchBillValue: '',
      searchBillLoading: false,

      province: '',
      city: '',
      resetArea: false,

      //渠道、包名
      packageName: 0,
      channel: 0,


      resumeStateArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '未通过', value: 3},
      ],
      resumeState: -1,

      forbiddenStateArray: [
        {label: '不限', value: -1},
        {label: '未封号', value: 0},
        {label: '已封号', value: 1},
      ],
      forbiddenState: -1,

      identityTypeArray: [
        {label: '不限', value: -1},
        {label: '未认证', value: 1},
        {label: '人脸', value: 2},
        {label: '人工', value: 3},
        {label: '人脸+人工', value: 4},
      ],
      identityType: -1,


    }
  },
  methods: {

    getChannelPackage(val) {
      // console.log(val)
      this.packageName = val[0];
      this.channel = val[1];
    },

    // 现居城市
    getArea(el) {
      // console.log(el)
      this.province = el.prov;
      this.city = el.city != '不限'?el.city:'';
      // if(this.homeCity != '' && this.homeCity != null && this.homeCity != '不限'){
      //   let c = this.selectCitys.indexOf(this.homeCity);
      //   if(c == -1){
      //     this.selectCitys.push(this.homeCity)
      //     this.submitCity()
      //   }else{
      //     this.$message({
      //       message: '你已经添加了改城市',
      //       type: "error"
      //     });
      //   }
      // }
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },

    getCheck(val) {
      this.isChecked = val
    },

    getBirthdayTime(val) {
      this.birthdayStartTime = val[0];
      this.birthdayEndTime = val[1];
    },

    getBirthdayCheck(val) {
      this.isBirthdayChecked = val
    },

    getRegTime(val) {
      this.regStartTime = val[0];
      this.regEndTime = val[1];
    },

    getRegCheck(val) {
      this.isRegChecked = val
    },


    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.resetArea = true
      this.isChecked = false;
      this.isBirthdayChecked = true;
      this.isRegChecked = true;
      this.vipId = 0;
      this.vipState = 1;
      this.state = -1;
      this.obtainMethod = -1;
      this.userSignedState = -1;
      this.vipPayMode = -1;
      this.vipPayType = -1;
      this.openNum = 0;
      this.searchValue = '';
      this.channel = 0;
      this.packageName = 0;
      this.resumeState = -1;
      this.forbiddenState = -1;
      this.identityType = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['vipId'] = this.vipId;
      param['vipState'] = this.vipState;
      param['state'] = this.state;
      param['obtainMethod'] = this.obtainMethod;
      param['openNum'] = this.openNum;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['birthdayStartTime'] = this.birthdayStartTime;
      param['birthdayEndTime'] = this.birthdayEndTime;
      param['regStartTime'] = this.regStartTime;
      param['regEndTime'] = this.regEndTime;
      param['searchValue'] = this.searchValue;
      param['searchType'] = this.searchType;
      param['userSignedState'] = this.userSignedState;
      param['vipPayMode'] = this.vipPayMode;
      param['vipPayType'] = this.vipPayType;
      param['province'] = this.province;
      param['city'] = this.city;
      param['packageNameId'] = this.packageName;
      param['channelId'] = this.channel;
      param['resumeState'] = this.resumeState;
      param['forbiddenState'] = this.forbiddenState;
      param['identityType'] = this.identityType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getVipUserPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //vip记录
      if(column.label == 'vip记录') {
        Dialog.open({
          title: 'vip记录',
          component: UserVipLogDialog,
          data: {
            id: row.userId
          },
          close: () => {

          }
        })
      }

      //婚恋服务购买记录
      if(column.label == 'SVIP记录') {
        Dialog.open({
          title: 'SVIP记录',
          component: MarriageLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
          }
        })
      }

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        component: VipUserSearchInfoDialog,
        data: {
          userForm: e,
          idx: -1,
          width: '600px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


    updateDialog(row) {
      // console.log(e)
      Dialog.open({
        component: UserUpdateDialog,
        data: {
          id: row.userId,
          width: '400px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    //隐藏
    updateExpire(idx, row, type) {
      this.$confirm('确定给昵称为【' + row.nickName + '】的用户' + (type == 2?'赠送终身VIP？':'解除VIP服务？')).then(()=>{
        this.pageDataList[idx].updateLoading = true
        let _this = this;
        let param = {};
        param['id'] = row.userId;
        param['type'] = type;
        param['day'] = 0;
        postFormData(updateVipUserExpire, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row.vipState = type
            row.expireDay = null
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx].updateLoading = false;
        })
            .catch(()=>{
              _this.pageDataList[idx].updateLoading = false;
            })
      })
    },

    getVipList() {
      getFormData(getVipAllList, {}).then((data) => {
        let {code, msg} = data;
        if (code == 200) {
          let vipArr = data.data;
          vipArr.map(item => {
            if(item.sex == 0) {
              this.vipBothArr.push(item)
            } else if (item.sex == 1) {
              this.vipManArr.push(item)
            } else if (item.sex == 2) {
              this.vipWomanArr.push(item)
            }
          })
          this.vipIdArray = this.vipIdArray.concat(this.vipManArr, this.vipWomanArr, this.vipBothArr)
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },
    sexChange(val) {
      this.vipIdArray = [
        {"name": "不限", "id": 0}
      ]
      if(val == -1) {
        this.vipIdArray = this.vipIdArray.concat(this.vipManArr, this.vipWomanArr, this.vipBothArr)
      } else if (val == 1) {
        this.vipIdArray = this.vipIdArray.concat(this.vipManArr,  this.vipBothArr)
      } else if (val == 2) {
        this.vipIdArray = this.vipIdArray.concat(this.vipWomanArr, this.vipBothArr)
      }
      this.vipExpire = this.vipIdArray[0]['id'];
    },

    getSearchBill() {
      if(!this.searchBillValue) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '订单号不能为空',
          type: 'warning'
        });
        return;
      }
      this.searchBillLoading = true
      let param = {};
      param['searchValue'] = this.searchBillValue;
      getFormData(getSearchBillInfo, param).then((data)=> {
        let {code, msg} = data;
        if (code == 200) {
          // console.log(data)
          Dialog.open({
            component: SearchBillInfoDialog,
            data: {
              userForm: data.data,
              width: '600px'
            },
            confirm: () => {
              // this.getPage()
            }
          })
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchBillLoading = false
      })
    }



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getVipList();
  }
}
</script>

<style scoped>

</style>
